
import { Component, Prop, Vue } from "vue-property-decorator";
import Restaurant from "../../domain/restaurant/Restaurant";
import RestaurantDialog from "@/components/restaurant/RestaurantDialog.vue";
@Component({
  components: { RestaurantDialog }
})
export default class RestaurantCard extends Vue {
  @Prop({ default: false })
  createNewRestaurant!: boolean;

  @Prop({
    default: function() {
      return new Restaurant();
    }
  })
  restaurant!: Restaurant;

  restaurantDialog = false;

  isManager() {
    return this.$store.getters.isManager;
  }

  get isNewRestaurant() {
    return this.restaurant.restaurantId == null;
  }

  async showRestaurantDialog() {
    this.restaurantDialog = true;
    if (!this.isNewRestaurant)
      await this.$store.dispatch("selectedRestaurant", this.restaurant);
  }

  addNewRestaurant(newRestaurant: Restaurant) {
    this.$emit("new-restaurant", newRestaurant);
  }

  removeRestaurant(toRemove: Restaurant) {
    this.$emit("delete-restaurant", toRemove);
  }
}
